import React, { useEffect } from 'react'
import * as S from './styles'
import { useTranslation } from 'next-i18next'

interface StepButtonsProps {
  currentStep: number
  handlePreviousStep?: () => void
  handleNextStep: () => void
  isSubmitting?: boolean
}

const StepButtons: React.FC<StepButtonsProps> = ({
  currentStep,
  handlePreviousStep,
  handleNextStep,
  isSubmitting = false
}) => {
  const { t } = useTranslation()

  const isLastStep = currentStep === 4

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && !isSubmitting) {
        handleNextStep()
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleNextStep, isSubmitting])

  return (
    <S.StepButtonsContainer emphasisNext={isLastStep}>
      {currentStep > 1 && (
        <S.StepButton onClick={handlePreviousStep} disabled={isSubmitting}>
          {t('contactPage.form.previousButton')}
        </S.StepButton>
      )}
      <S.StepButton
        next
        onClick={handleNextStep}
        emphasis={isLastStep}
        disabled={isSubmitting}
        aria-busy={isSubmitting && isLastStep}
      >
        {isLastStep && isSubmitting ? (
          <span className="loading-content">
            <span className="loading-spinner" aria-hidden="true"></span>
            {t('contactPage.form.submitting')}
          </span>
        ) : isLastStep ? (
          t('contactPage.form.submitButton')
        ) : (
          t('contactPage.form.nextButton')
        )}
      </S.StepButton>
    </S.StepButtonsContainer>
  )
}

export default StepButtons
